import { animationTransition } from '@shared/utils/animationTransition';
import { styled, Box, StyleSystemProps } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const StyledSearchInputBarRoot = styled(Box)``;
export const StyledInput = styled(Box)``;
export const StyledEndEnhancementContainer = styled(Box)``;

const rootStyles: StyleSystemProps = {
  display: 'flex',
  position: 'relative',
  width: '100%'
};

const inputStyles: CSSObject = {
  height: [8, null, 9],
  width: '100%',
  outline: 'transparent solid 2px',
  backgroundColor: 'white',
  borderRadius: 'full',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'mono5',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.03), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 9px 36px -30px rgba(0, 0, 0, 0.04);',
  paddingLeft: [8, null, 6],
  paddingRight: '86px',
  typographyVariant: 'body1',
  fontSize: '1rem', // needed to prevent mobile safari from zooming on input focus
  transition: animationTransition('border-color'),
  _hover: {
    borderColor: 'mono7'
  },
  _focusVisible: {
    borderColor: 'mono10'
  },
  _placeholder: {
    color: 'typeDisabledDark'
  },
  appearance: 'none',
  '&::-webkit-search-decoration': {
    appearance: 'none'
  },
  '&::-webkit-search-cancel-button': {
    appearance: 'none'
  }
};

const endEnhancementContainerStyles = (end: boolean): StyleSystemProps => ({
  position: 'absolute',
  top: 0,
  [end ? 'right' : 'left']: 3,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%'
});

export const styles = {
  root: rootStyles,
  input: inputStyles,
  endEnhancementContainer: endEnhancementContainerStyles
};
